var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import gql from 'graphql-tag';
import { css } from '@emotion/core';
import { ListingType } from '@domain-group/fe-allhomes-library';
import { AgentSideboxGraphQL } from '@domain-group/fe-co-allhomes-enquiry-form';
import ShareButtons from '@domain-group/fe-co-allhomes-share-buttons';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { jsx as ___EmotionJSX } from "@emotion/core";
var shareButtonsStyle = {
  name: "er6if3",
  styles: "margin-top:24px;width:100%;"
};
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment OnMarketSidebox on Property {\n    address {\n      line1\n      division {\n        name\n      }\n    }\n    ...AgentSidebox\n  }\n  ", "\n"])), AgentSideboxGraphQL.fragment);
var OnMarketSidebox = _ref => {
  var _property$address$div;
  var property = _ref.property,
    applyOnlineLink = _ref.applyOnlineLink,
    emailAFriendLink = _ref.emailAFriendLink,
    printFriendlyLink = _ref.printFriendlyLink,
    _ref$onEmailClick = _ref.onEmailClick,
    onEmailClick = _ref$onEmailClick === void 0 ? () => {} : _ref$onEmailClick;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(AgentSideboxGraphQL, {
    property: property,
    applyOnlineLink: applyOnlineLink,
    onEmailClick: onEmailClick
  }), property.listing.type !== ListingType.SALES_EARLY_ACCESS.name && ___EmotionJSX(EventBoundary, {
    name: "share"
  }, ___EmotionJSX(ShareButtons, {
    css: shareButtonsStyle,
    title: "".concat(property.address.line1, ", ").concat((_property$address$div = property.address.division) === null || _property$address$div === void 0 ? void 0 : _property$address$div.name),
    facebook: true,
    twitter: true,
    email: {
      enabled: true,
      link: emailAFriendLink
    },
    print: {
      enabled: property.listing.type !== ListingType.DEVELOPMENTS_RESIDENTIAL.name,
      link: printFriendlyLink
    }
  })));
};
OnMarketSidebox.fragment = fragment;
export default OnMarketSidebox;